__webpack_require__.p = "https://ui.prod.us-east-1.urc.advertising.amazon.dev/";